import { DynamicConf } from '@parship/psg-interfaces';

export default class StayLoggedInModal {
	protected dynamicConf: DynamicConf;

	public constructor(dynamicConf: DynamicConf) {
		this.dynamicConf = dynamicConf;
	}

	public show(): void {
		const modalBox: HTMLDialogElement = document.querySelector('.stay-logged-in-modal');
		const headline: HTMLSpanElement = modalBox.querySelector('.modalbox-headline');
		const text: HTMLParagraphElement = modalBox.querySelector('.modalbox-text');
		const closeButton: HTMLButtonElement = modalBox.querySelector('.wp-block-button');

		headline.textContent = this.dynamicConf.login?.stayLoggedInModal?.headline;
		text.textContent = this.dynamicConf.login?.stayLoggedInModal?.text;
		closeButton.addEventListener('click', () => modalBox.close());

		modalBox.showModal();
	}
}
